import { NudosTextArea, NudosUploadDownloadButton } from '../../../../NudosComponents';
import { validateImageOrPdfCallback, validateCsvCallback } from '../../../../../utils/validateFiles';
import { ADDITIONAL_SERVICE_CLASS_TYPE } from '../../../../../types/product.configuration.types';
import {
  IadditionalServiceDataForToolLogistics,
  CONFIG_STATUS_NAME
} from '../../../../../types/product.configuration.types';
import './CompletedAdditionalServiceFields.scss';

const CompletedAdditionalServiceFields = ({
  evidenceComments,
  setEvidenceComments,
  additionalServiceData,
  uploadProofFile,
  uploadCsvFile
}: CompletedAdditionalServiceFieldsProps) => {
  const { configClassName, status } = additionalServiceData;
  const configurationIsCreateAdmin = configClassName === ADDITIONAL_SERVICE_CLASS_TYPE.CREATE_ADMIN;
  const configurationIsHashId = configClassName === ADDITIONAL_SERVICE_CLASS_TYPE.HASH_ID;
  const customPdfOrJpgUploaderWidth = configurationIsCreateAdmin ? '280px' : '127px';
  const { statusName, configurationImageUrls, imageUrl: additionalServiceImageUrl } = status || {};
  const imageUrl = configurationImageUrls?.[0] || additionalServiceImageUrl || undefined;
  const statusIsCompleted = statusName === CONFIG_STATUS_NAME.COMPLETED;
  const currentFileUrl = statusIsCompleted ? imageUrl : undefined;
  const textValueForEvidenceComments =
    statusIsCompleted && configurationIsCreateAdmin ? status?.evidenceComments || '' : evidenceComments || '';

  return (
    <div className="completedAdditionalServiceFields">
      {configurationIsCreateAdmin && (
        <NudosTextArea
          label="Preguntas de seguridad"
          placeholder="Escribe las preguntas de seguridad y sus respuestas"
          currentValue={textValueForEvidenceComments}
          maxLength={500}
          setCurrentValue={setEvidenceComments}
          componentSize="medium"
          textHeight={64}
          noResize
          hidenCounter
        />
      )}

      <div className={`uploadersContainer ${configurationIsCreateAdmin ? 'hasTextArea' : 'noTextArea'}`}>
        <NudosUploadDownloadButton
          customClassName="uploadProofButton"
          customWidth={customPdfOrJpgUploaderWidth}
          uploadedFileHandler={uploadProofFile}
          downloadButtonText="Consultar evidencia"
          buttonEmptyText="PDF o JPG"
          buttonFilledText="PDF o JPG"
          showSkeletonLoader={false}
          keepOwnFileState
          currentFileUrl={currentFileUrl}
          validateFileCallback={validateImageOrPdfCallback}
        />
        {configurationIsHashId && (
          <NudosUploadDownloadButton
            customClassName="uploadCsvButton"
            customWidth="127px"
            uploadedFileHandler={uploadCsvFile}
            downloadButtonText="Consultar evidencia"
            buttonEmptyText="CSV"
            buttonFilledText="CSV"
            showSkeletonLoader={false}
            keepOwnFileState
            validateFileCallback={validateCsvCallback}
          />
        )}
      </div>
    </div>
  );
};

export default CompletedAdditionalServiceFields;

export interface CompletedAdditionalServiceFieldsProps {
  additionalServiceData: IadditionalServiceDataForToolLogistics;
  uploadProofFile: (file?: File) => void;
  uploadCsvFile: (file?: File) => void;
  evidenceComments: string | undefined;
  setEvidenceComments: React.Dispatch<React.SetStateAction<string>>;
}
